import apiClient from "../../services/apiClient";
import { MAIN_SITE_URL } from "../../services/site.config";
import { trackEvent } from "../analytics/analytics";

/**
 * S117 step 1: "Who is this for?" once, on an account's first finish act
 * (memory/sessions/117-send-to-buyers-v1.md). The server decides who sees it (`OutputFork` /
 * `OutputForkService`, flag `Features:OutputFork`) and records the answer in dbo.Surveys and
 * Analytics.Events; the client only renders it.
 */

export type OutputForkSurface = "publish" | "pdf-designer" | "pdf-concierge";
export type OutputForkAnswer = "buyers" | "one_off" | "dismissed";

/** Public KB articles the buyers branch links to (`assets/ai-copilot/articles`, S117 KB). */
export const OUTPUT_FORK_KB = {
  lineSheet: `${MAIN_SITE_URL}/resources/kb/line-sheet`,
  buyerPrices: `${MAIN_SITE_URL}/resources/kb/different-prices-for-different-buyers`,
};

/** True when this act shows the fork. Spends the account's one showing; any failure reads as no. */
export const takeOutputFork = async (
  surface: OutputForkSurface,
): Promise<boolean> => {
  try {
    const { data } = await apiClient.post<{ show?: boolean }>(
      "/account/output-fork/take",
      { surface },
    );
    return data?.show === true;
  } catch {
    return false;
  }
};

/** Fire and forget: the fork never waits on the write. The first answer is the record. */
export const answerOutputFork = (
  surface: OutputForkSurface,
  answer: OutputForkAnswer,
) => {
  apiClient
    .post("/account/output-fork/answer", { surface, answer })
    .catch(() => undefined);
};

/** What the user did after answering: copy-link, line-sheet, showroom, buyer-prices, publish-link, keep-pdf. */
export const trackOutputForkNext = (surface: OutputForkSurface, next: string) =>
  trackEvent({
    category: "catalog",
    action: "output-fork-next",
    label: surface + ":" + next,
  });
